import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import i18n from './i18n';
import '@/assets/font/iconfont';
import '@/assets/styles/global.less';
import vueResource from 'vue-resource';
import 'amfe-flexible';
import VConsole from 'vconsole';

const config = process.env.NODE_ENV === 'development' ? window.config.dev : window.config.prod;

if (config.vConsole) {
  new VConsole();
}
Vue.config.productionTip = false;
Vue.use(vueResource);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
